module.exports = __webpack_public_path__ + "img/V5.bee054dc.jpg";